import options$1 from './cargoWise.js';

const options = JSON.parse(JSON.stringify(options$1));
options.name = 'CargoWise';
options.density = 'comfortable';
options.colors.light.app.brandColor = '#371ee1';
options.colors.light.app.brandColorDark = true;
options.colors.light.app.brandLoginColor = '#371ee1';
options.colors.light.app.brandLoginColorDark = true;
options.colors.muted.app.brandColor = '#30302e';
options.colors.muted.app.brandColorDark = true;
options.colors.muted.app.brandLoginColor = '#30302e';
options.colors.muted.app.brandLoginColorDark = true;
options.colors.dark.app.brandColor = '#181C33';
options.colors.dark.app.brandColorDark = true;
options.colors.dark.app.brandLoginColor = '#7486DC';
options.colors.dark.app.brandLoginColorDark = true;
options.logoLightImage = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 255 62" style="enable-background:new 0 0 255 62;" xml:space="preserve">
<style type="text/css">
.st0{fill:#FFFFFF;}
</style>
<path class="st0" d="M77.7,18.4c0-2.7,1-5.2,2.9-7.1c1.9-1.9,4.4-2.9,7.1-2.9c4.3,0,7.6,2.4,9.1,5.9l-3.7,1.6
c-0.9-2.2-3-3.6-5.4-3.6c-3.4,0-6,2.7-6,6.1c0,1.6,0.6,3.2,1.8,4.4c1.1,1.2,2.7,1.8,4.3,1.8c2.6,0,4.5-1.6,5.4-3.8l3.7,1.6
c-1.5,3.5-4.7,6-9.2,6c-2.7,0-5.2-1-7.1-2.9C78.8,23.6,77.7,21.1,77.7,18.4z M107.9,8.4c-5,0-9.6,3.8-9.6,10c0,6.1,4.7,10,9.6,10
c2.5,0,4.8-1.1,6.4-3V28h4.1V8.8h-4.1v2.5C112.8,9.5,110.4,8.4,107.9,8.4z M108.4,12.2c3.5,0,6.1,2.8,6.1,6.2h0c0,3.4-2.6,6.2-6,6.2
c-3.4,0-6.1-2.8-6.1-6.2S105,12.2,108.4,12.2z M121.9,8.8h4.1v3c1-2,2.9-3,5.6-3h1.8v3.9H131c-3.5,0-4.9,1.8-4.9,5.8V28h-4.2V8.8z
M144.1,8.4c-5,0-9.6,3.8-9.6,10c0,6.1,4.7,10,9.5,10c2.5,0,4.9-1.1,6.4-3.1v2.4c0,3.3-2.1,5.9-5.6,5.9c-2.9,0-4.8-1.3-5.7-3.5
l-3.8,1.8c1.5,3.1,4.7,5.4,9.5,5.4c6.1,0,9.7-4.1,9.7-9.8V8.8h-4.1v2.6C148.9,9.5,146.6,8.4,144.1,8.4z M144.6,12.2
c3.5,0,6.1,2.8,6.1,6.2h0c0,3.4-2.6,6.2-6.1,6.2c-3.4,0-6.1-2.8-6.1-6.2S141.2,12.2,144.6,12.2z M167.3,8.5c-5.5,0-10,4.4-10,9.9
c0,2.6,1,5.2,2.9,7.1c1.9,1.9,4.4,2.9,7.1,2.9c5.5,0,10-4.4,10-9.9C177.2,13,172.8,8.5,167.3,8.5z M167.2,12.3
c3.3,0,5.9,2.8,5.9,6.1s-2.6,6.1-5.9,6.1c-3.3,0-5.9-2.8-5.9-6.1S163.9,12.3,167.2,12.3z M177.7,8.8l4.2,0l4.4,13.6l5-13.6h4.1
l4.9,13.6l4.5-13.6h4.2L202.3,28h-4l-5.1-13.7L188.1,28h-4L177.7,8.8z M215.6,2c-0.4-1-1.4-1.7-2.6-1.7c-0.7,0-1.5,0.3-2,0.8
c-0.5,0.5-0.8,1.2-0.8,2c0,1.1,0.7,2.1,1.7,2.6c1,0.4,2.2,0.2,3-0.6C215.8,4.3,216,3.1,215.6,2z M215.1,8.8H211V28h4.1V8.8z
M217.1,24l3.7-2c1.1,1.8,2.8,2.8,5.1,2.8c2.4,0,3.6-1.2,3.6-2.5c0-1.6-2.3-1.9-4.8-2.5c-3.3-0.7-6.7-1.7-6.7-5.7
c0-3,2.9-5.8,7.5-5.8c3.7,0,6.2,1.4,7.8,3.7l-3.5,1.9c-0.9-1.4-2.3-2.2-4.4-2.2c-2.3,0-3.3,1-3.3,2.3c0,1.4,1.6,1.7,4.6,2.3
c3.2,0.7,6.9,1.8,6.9,5.8c0,2.9-2.6,6.2-7.9,6.1C221.5,28.4,218.7,26.9,217.1,24z M245,8.4c-5.6,0-10,4.4-10,10
c0,5.6,4.1,9.9,10.1,9.9c4.3,0,7.3-2.1,9-5.2l-3.4-1.9c-1,2.2-3.2,3.5-5.6,3.5c-3.3,0-5.6-1.9-6.2-4.9h15.9v-1.6
C254.9,12.5,250.7,8.4,245,8.4z M250.7,16.3h-11.5h0c0.8-2.6,3.1-4.3,5.8-4.3C248,12,250.1,13.6,250.7,16.3z M28,5.6H11.2V0H28V5.6z
M0,22.4h16.8l0,5.6H0V22.4z M11.2,61.6H28V56H11.2V61.6z M33.6,5.6V0h28v5.6H33.6z M33.6,16.8h28v-5.6h-28V16.8z M61.6,28h-28v-5.6
h28V28z M28,33.6H0v5.6h28V33.6z M61.5,50.4h-28v-5.6h28V50.4z"/>
</svg>
`;
options.logoDarkImage = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 255 62" style="enable-background:new 0 0 255 62;" xml:space="preserve">
<style type="text/css">
.st0{fill:#371EE1;}
</style>
<path class="st0" d="M77.7,18.4c0-2.7,1-5.2,2.9-7.1c1.9-1.9,4.4-2.9,7.1-2.9c4.3,0,7.6,2.4,9.1,5.9l-3.7,1.6
c-0.9-2.2-3-3.6-5.4-3.6c-3.4,0-6,2.7-6,6.1c0,1.6,0.6,3.2,1.8,4.4c1.1,1.2,2.7,1.8,4.3,1.8c2.6,0,4.5-1.6,5.4-3.8l3.7,1.6
c-1.5,3.5-4.7,6-9.2,6c-2.7,0-5.2-1-7.1-2.9C78.8,23.6,77.7,21.1,77.7,18.4z M107.9,8.4c-5,0-9.6,3.8-9.6,10c0,6.1,4.7,10,9.6,10
c2.5,0,4.8-1.1,6.4-3V28h4.1V8.8h-4.1v2.5C112.8,9.5,110.4,8.4,107.9,8.4z M108.4,12.2c3.5,0,6.1,2.8,6.1,6.2h0c0,3.4-2.6,6.2-6,6.2
c-3.4,0-6.1-2.8-6.1-6.2S105,12.2,108.4,12.2z M121.9,8.8h4.1v3c1-2,2.9-3,5.6-3h1.8v3.9H131c-3.5,0-4.9,1.8-4.9,5.8V28h-4.2V8.8z
M144.1,8.4c-5,0-9.6,3.8-9.6,10c0,6.1,4.7,10,9.5,10c2.5,0,4.9-1.1,6.4-3.1v2.4c0,3.3-2.1,5.9-5.6,5.9c-2.9,0-4.8-1.3-5.7-3.5
l-3.8,1.8c1.5,3.1,4.7,5.4,9.5,5.4c6.1,0,9.7-4.1,9.7-9.8V8.8h-4.1v2.6C148.9,9.5,146.6,8.4,144.1,8.4z M144.6,12.2
c3.5,0,6.1,2.8,6.1,6.2h0c0,3.4-2.6,6.2-6.1,6.2c-3.4,0-6.1-2.8-6.1-6.2S141.2,12.2,144.6,12.2z M167.3,8.5c-5.5,0-10,4.4-10,9.9
c0,2.6,1,5.2,2.9,7.1c1.9,1.9,4.4,2.9,7.1,2.9c5.5,0,10-4.4,10-9.9C177.2,13,172.8,8.5,167.3,8.5z M167.2,12.3
c3.3,0,5.9,2.8,5.9,6.1s-2.6,6.1-5.9,6.1c-3.3,0-5.9-2.8-5.9-6.1S163.9,12.3,167.2,12.3z M177.7,8.8l4.2,0l4.4,13.6l5-13.6h4.1
l4.9,13.6l4.5-13.6h4.2L202.3,28h-4l-5.1-13.7L188.1,28h-4L177.7,8.8z M215.6,2c-0.4-1-1.4-1.7-2.6-1.7c-0.7,0-1.5,0.3-2,0.8
c-0.5,0.5-0.8,1.2-0.8,2c0,1.1,0.7,2.1,1.7,2.6c1,0.4,2.2,0.2,3-0.6C215.8,4.3,216,3.1,215.6,2z M215.1,8.8H211V28h4.1V8.8z
M217.1,24l3.7-2c1.1,1.8,2.8,2.8,5.1,2.8c2.4,0,3.6-1.2,3.6-2.5c0-1.6-2.3-1.9-4.8-2.5c-3.3-0.7-6.7-1.7-6.7-5.7
c0-3,2.9-5.8,7.5-5.8c3.7,0,6.2,1.4,7.8,3.7l-3.5,1.9c-0.9-1.4-2.3-2.2-4.4-2.2c-2.3,0-3.3,1-3.3,2.3c0,1.4,1.6,1.7,4.6,2.3
c3.2,0.7,6.9,1.8,6.9,5.8c0,2.9-2.6,6.2-7.9,6.1C221.5,28.4,218.7,26.9,217.1,24z M245,8.4c-5.6,0-10,4.4-10,10
c0,5.6,4.1,9.9,10.1,9.9c4.3,0,7.3-2.1,9-5.2l-3.4-1.9c-1,2.2-3.2,3.5-5.6,3.5c-3.3,0-5.6-1.9-6.2-4.9h15.9v-1.6
C254.9,12.5,250.7,8.4,245,8.4z M250.7,16.3h-11.5h0c0.8-2.6,3.1-4.3,5.8-4.3C248,12,250.1,13.6,250.7,16.3z M28,5.6H11.2V0H28V5.6z
M0,22.4h16.8l0,5.6H0V22.4z M11.2,61.6H28V56H11.2V61.6z M33.6,5.6V0h28v5.6H33.6z M33.6,16.8h28v-5.6h-28V16.8z M61.6,28h-28v-5.6
h28V28z M28,33.6H0v5.6h28V33.6z M61.5,50.4h-28v-5.6h28V50.4z"/>
</svg>
`;
options.logoLightImageFileType = 'image/svg+xml';
options.logoDarkImageFileType = 'image/svg+xml';

export { options as default };
